import React from "react";
import BreadCrumb from "Common/BreadCrumb";
import { Activity } from "lucide-react";
import { ToastContainer } from "react-toastify";
import useActivities from "hooks/useActivities";

const Activities = () => {
  const { data, isLoading, hasNextPage, handleEndReached } = useActivities();

  return (
    <React.Fragment>
      <BreadCrumb title="Activity Logs" pageTitle="Activity Logs" />
      <ToastContainer closeButton={false} limit={1} />

      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        {isLoading ? (
          <div className="py-12 text-center text-sm text-gray-400">Loading activity logs…</div>
        ) : (data?.length ?? 0) === 0 ? (
          <div className="py-16 text-center">
            <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <Activity size={22} className="text-gray-400" />
            </div>
            <p className="text-sm text-gray-500">No activity logs yet</p>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table data-stack className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-200">
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Admin</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Activity</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Date</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {data?.map((activity) => (
                    <tr key={activity._id} className="hover:bg-gray-50 transition-colors">
                      <td data-label="Admin" data-cell="title" className="px-4 py-3">
                        <p className="font-medium text-gray-900">
                          {activity?.user?.firstName} {activity?.user?.lastName}
                        </p>
                      </td>
                      <td data-label="Activity" data-cell="block" className="px-4 py-3 text-gray-600">{activity.activity}</td>
                      <td data-label="Date" className="px-4 py-3 text-gray-500">
                        {new Date(activity.createdAt).toLocaleDateString()}{" "}
                        {new Date(activity.createdAt).toLocaleTimeString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {hasNextPage && (
              <div className="flex justify-end px-4 py-3 border-t border-gray-100">
                <button
                  className="text-sm text-indigo-600 hover:underline"
                  onClick={() => handleEndReached()}
                >
                  Load more
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default Activities;
